import React from "react";
import { Box, Typography, Grid } from "@mui/material";

const TransactionHeader = ({ classes, docDetail }) => {
  return (
    <Box className={classes.transactionDetailSection} sx={{ mt: "30px" }}>
      <Typography className={classes.transactionDetailHead}>
        I am working with:{" "}
        <span>
          {docDetail?.data?.representation_side === "buying"
            ? "Buyers"
            : "Sellers"}{" "}
        </span>{" "}
        for
        <span> {docDetail?.data?.name}</span> <a> Edit People</a>
      </Typography>
      <Grid container spacing={2} sx={{ mt: "10px", justifyContent: "center" }}>
        {docDetail?.data?.buyers?.length ? (
          <Grid item xs={3}>
            <Typography className={classes.transactionContTop}>
              Full Legal Names of All buyer(s)
            </Typography>
            <Typography className={classes.transactionContBottom}>
              {docDetail?.data?.buyers
                ?.map((item) => `${item.first_name} ${item?.last_name}`)
                ?.join(", ")}
            </Typography>
          </Grid>
        ) : null}

        {docDetail?.data?.sellers?.length ? (
          <Grid item xs={3}>
            <Typography className={classes.transactionContTop}>
              Full Legal Names of All seller(s)
            </Typography>
            <Typography className={classes.transactionContBottom}>
              {docDetail?.data?.sellers
                ?.map((item) => `${item.first_name} ${item?.last_name}`)
                ?.join(", ")}
            </Typography>
          </Grid>
        ) : null}

        {docDetail?.data?.buyer_brokers?.length ? (
          <Grid item xs={3}>
            <Typography className={classes.transactionContTop}>
              Name of Buying Broker/Salesperson
            </Typography>
            <Typography className={classes.transactionContBottom}>
              {docDetail?.data?.buyer_brokers
                ?.map((item) => `${item.first_name} ${item?.last_name}`)
                ?.join(", ")}
            </Typography>
          </Grid>
        ) : null}

        {docDetail?.data?.seller_brokers?.length ? (
          <Grid item xs={3}>
            <Typography className={classes.transactionContTop}>
              Name of Selling Broker/Salesperson
            </Typography>
            <Typography className={classes.transactionContBottom}>
              {docDetail?.data?.seller_brokers
                ?.map((item) => `${item.first_name} ${item?.last_name}`)
                ?.join(", ")}
            </Typography>
          </Grid>
        ) : null}

        {docDetail?.data?.seller_brokers?.length ? (
          <Grid item xs={12}>
            <Typography className={classes.transactionContTop}>
              Name of Listing Broker/Salesperson
            </Typography>
            <Typography className={classes.transactionContBottom}>
              {docDetail?.data?.seller_brokers
                ?.map((item) => `${item.first_name} ${item?.last_name}`)
                ?.join(", ")}
            </Typography>
          </Grid>
        ) : null}
      </Grid>
    </Box>
  );
};

export default TransactionHeader;
